// Used for any slice / page containing Judge.me widgets
// See 'src/slices/Reviews' for an example

import { useEffect } from "react";
import { useAppContext } from "~hooks";

const useJudgeMe = () => {
  const { judgeMeLoaded, setJudgeMeLoaded } = useAppContext();

  const install = () => {
    if (judgeMeLoaded) {
      return;
    }

    const jdgmScript = document.createElement(`script`);

    jdgmScript.dataset.judgeMeScript = ``;
    jdgmScript.textContent = `
  		jdgm = window.jdgm || {};
      jdgm.SHOP_DOMAIN = 'loungeface.myshopify.com';
      jdgm.PLATFORM = 'shopify';
      jdgm.PUBLIC_TOKEN = 'MeVmzd0F3wH8uF0ApItgiIRCPks';
    `;

    const preloaderScript = document.createElement(`script`);
    preloaderScript.dataset.judgeMeScript = ``;
    preloaderScript.id = `judge-me-preloader`; // prevent duplicates
    preloaderScript.src = `https://cdn.judge.me/widget_preloader.js`;
    preloaderScript.async = true;
    preloaderScript.setAttribute(`data-cfasync`, `false`);

    const installedScript = document.createElement(`script`);
    installedScript.dataset.judgeMeScript = ``;
    installedScript.src = `https://cdn1.judge.me/assets/installed.js`;
    installedScript.async = true;
    installedScript.setAttribute(`data-cfasync`, `false`);

    document.head.appendChild(jdgmScript);
    document.head.appendChild(preloaderScript);
    document.head.appendChild(installedScript);

    setJudgeMeLoaded(true);
  };

  const reload = () => {
    if (typeof window?.jdgmCacheServer === `undefined`) {
      return;
    }

    window.jdgmCacheServer.reloadAll();
  };

  useEffect(() => {
    if (judgeMeLoaded || typeof document === `undefined`) {
      return;
    }

    const installedScript = document.querySelector(`#judge-me-preloader`);

    if (installedScript) {
      return;
    }

    install();
  }, []);

  // ---------------------------------------------------------------------------

  return {
    installed: judgeMeLoaded,
    reload
  };
};

export default useJudgeMe;
